module.exports = __webpack_public_path__ + "img/billy_success.c6a48f6f.svg";